import { all, call, CallEffect, fork, put, PutEffect, takeEvery, } from "redux-saga/effects";
import { ActionTypes } from "../../constants/ActionTypes";
import { fetchSecretariatListSuccess } from "../actions";
import { ShowError } from "../../helper/Alert";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

const getSecretariatList = async (str: string | null) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`searchLetter/GetSecretariatToSecretariatFormats?searchText=${str || ""}`);
}

function* fetchSecretariatListRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedSecretariatList = yield call(getSecretariatList, action.payload);
        yield put(fetchSecretariatListSuccess(fetchedSecretariatList.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchSecretariatList() {
    yield takeEvery(ActionTypes.GET_SECRETARIAT_LIST, fetchSecretariatListRequest);
}

export default function* rootSaga() {
    yield all([fork(fetchSecretariatList)]);
}

